import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";

import { chageEstadoMD, chageEstadoMP, chageEstadoPlanillas, chageEstadoTurnos, getMotivosDeducciones, getMotivosPago, getNominas} from "../../../../API/RRHH/Maestros/MaestrosRequest";
import NominasCRUD from "./NominasCRUD";
import { Dropdown } from "primereact/dropdown";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { toastShow } from "../../../../Base/Services/ToastService";
import { confirmDialog } from "primereact/confirmdialog";
import { getTurnos } from "../../../../API/RRHH/Posiciones/PosicionesRequest";
import TurnosCRUD from "./TurnosCRUD";
import { Checkbox } from "primereact/checkbox";
import MotivosPagoCRUD from "./MotivosPagoCRUD";
import MotivosDeduccionesCRUD from "./MotivosDeduccionesCRUD";

const MaestrosScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogTurnos, setShowDialogTurnos] = useState(false);
  const [showDialogPagos, setShowDialogPagos] = useState(false);
  const [showDialogDeducciones, setShowDialogDeducciones] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);

  const getInfo = async () => {
    setLoading(true);
    setSelected([])

    let dataTempo

    if(activeIndex === 0){
      dataTempo = await getNominas();
    }else if(activeIndex === 1){
      dataTempo = await getTurnos()
    }else if(activeIndex === 2){
      dataTempo = await getMotivosPago()
    }else if(activeIndex ===3){
      dataTempo = await getMotivosDeducciones()
    }

    setData(dataTempo);

    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    setLoading(false);
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdNomina: item.IdNomina,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdNomina: data.IdNomina,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Planillas ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdNominas = changes.map((item) => item.IdNomina);
                cambiarEstado(e.value.IdStatus, IdNominas.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdNominas) => {
    const result = await chageEstadoPlanillas({ IdStatus, IdNominas });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const changeEstado2 = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdTurno: item.IdTurno,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdTurno: data.IdTurno,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Turnos ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdTurnos = changes.map((item) => item.IdTurno);
                cambiarEstado2(e.value.IdStatus, IdTurnos.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado2 = async (IdStatus, IdTurnos) => {
    const result = await chageEstadoTurnos({ IdStatus, IdTurnos });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };
  
  const changeEstadoMP = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdMotivoPago: item.IdMotivoPago,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdMotivoPago: data.IdMotivoPago,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Motivos de Pago ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdMotivosPago = changes.map((item) => item.IdMotivoPago);
                cambiarEstadoMP(e.value.IdStatus, IdMotivosPago.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstadoMP = async (IdStatus, IdMotivosPago) => {
    const result = await chageEstadoMP({ IdStatus, IdMotivosPago });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const changeEstadoMD = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdMotivoDeduccion: item.IdMotivoDeduccion,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdMotivoDeduccion: data.IdMotivoDeduccion,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Motivos de Deducción ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdMotivosDeduccion = changes.map((item) => item.IdMotivoDeduccion);
                cambiarEstadoMD(e.value.IdStatus, IdMotivosDeduccion.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstadoMD = async (IdStatus, IdMotivosDeduccion) => {
    const result = await chageEstadoMD({ IdStatus, IdMotivosDeduccion });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const columns = [
    {
      field: "IdNomina",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNomina > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Nomina",
      headerEn: "Payroll",
      header: "Nómina",
      frozen: 1,
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNomina > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Horas",
      header: "Horas",
      frozen: 1,
      headerEn: "Hours",
      className: "small",
      Format: "Currency",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdNomina > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: (rowData) => {
        if(rowData.data?.IdNomina){
          return true
        }else{
          return false
        }
      }
    },
    {
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdPosicion > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      className: "Xlarge",
      flex: 1,
      minWidth: 300,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdPosicion > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creado",
      headerEn: "Date Create",
      Format: "DateTime",
      className: "medium",
    },
    {
      field: "UserNameCreate",
      header: "User Create",
      headerEn: "User Create",
      className: "medium",
    },
    {
      field: "IdNomina",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdNomina > 0) {
              setShowDialog(true);
              setSelected([rowData]);
            }
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {},
  };

  const columnsTurnos = [
    {
      field: "IdTurno",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdTurno > 0) {
          setShowDialogTurnos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Turno",
      headerEn: "Turno",
      header: "Turno",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdTurno > 0) {
          setShowDialogTurnos(true);
          setSelected([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "small",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado2,
      editable: (rowData) => {
        if(rowData.data?.IdTurno){
          return true
        }else{
          return false
        }
      }
    },
    {
      field: "HoraEntrada",
      headerEn: "Hora Entrada",
      header: "Hora Entrada",
      className: "small",
      Format: 'Time',
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdTurno > 0) {
          setShowDialogTurnos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "HoraSalida",
      headerEn: "Hora Salida",
      header: "Hora Salida",
      Format: 'Time',
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdTurno > 0) {
          setShowDialogTurnos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DiferenteHorario",
      headerEn: "Viernes Diferente Horario",
      header: "Viernes Diferente Horario",
      className: "small",
      Format: 'Template',
      body: (rowData) =>
        rowData?.IdTurno && (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <Checkbox checked={rowData.DiferenteHorario} />
          </div>
        ),
    },
    {
      field: "HoraEntradaV",
      headerEn: "Hora Entrada Viernes",
      header: "Hora Entrada Viernes",
      className: "small",
      Format: 'Time',
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdTurno > 0) {
          setShowDialogTurnos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "HoraSalidaV",
      headerEn: "Hora Salida Viernes",
      header: "Hora Salida Viernes",
      className: "small",
      Format: 'Time',
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdTurno > 0) {
          setShowDialogTurnos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      className: "Xlarge",
      flex: 1,
      minWidth: 300,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdTurno > 0) {
          setShowDialogTurnos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DateEditStr",
      header: "Fecha Editado",
      headerEn: "Date Edit",
      Format: "DateTime",
      className: "medium",
    },
    {
      field: "UserNameEdit",
      header: "User Edit",
      headerEn: "User Edit",
      className: "medium",
    },
    {
      field: "IdTurno",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdTurno > 0) {
              setShowDialogTurnos(true);
              setSelected([rowData]);
            }
          },
        },
      ],
    },
  ];

  const tableTurnos = {
    Columns: columnsTurnos,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {},
  };

  const columnsPago = [
    {
      field: "IdMotivoPago",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      frozen: 1,
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      Format: "Estado",
      frozen: 1,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstadoMP,
      editable: (rowData) => {
        if(rowData.data?.IdMotivoPago){
          return true
        }else{
          return false
        }
      }
    },
    {
      field: "MotivoPago",
      header: "Motivo",
      headerEn: "Reason",
      className: "Xlarge",
      flex: 1,
      minWidth: 250,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdMotivoPago > 0) {
          setShowDialogPagos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "Xlarge",
      flex: 1,
      minWidth: 250,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdMotivoPago > 0) {
          setShowDialogPagos(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creado",
      headerEn: "Date Created",
      Format: "DateTime",
      className: "medium",
    },
    {
      field: "UserNameCreate",
      header: "Creado Por",
      headerEn: "Created By",
      className: "medium",
    },
    {
      field: "DateEditStr",
      header: "Fecha Editado",
      headerEn: "Date Edited",
      Format: "DateTime",
      className: "medium",
    },
    {
      field: "UserNameEdit",
      header: "Editado Por",
      headerEn: "Edited By",
      className: "medium",
    },
    {
      field: "IdMotivoPago",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdMotivoPago > 0) {
              setShowDialogPagos(true);
              setSelected([rowData]);
            }
          },
        },
      ],
    },
  ];
  
  const tablePago = {
    Columns: columnsPago,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {},
  };

  const columnsDeducciones = [
    {
      field: "IdMotivoDeduccion",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      frozen: 1,
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      Format: "Estado",
      frozen: 1,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstadoMD,
      editable: (rowData) => {
        if(rowData.data?.IdMotivoDeduccion){
          return true
        }else{
          return false
        }
      }
    },
    {
      field: "MotivoDeduccion",
      header: "Motivo",
      headerEn: "Reason",
      className: "Xlarge",
      flex: 1,
      minWidth: 250,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdMotivoDeduccion > 0) {
          setShowDialogDeducciones(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "Xlarge",
      flex: 1,
      minWidth: 250,      
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdMotivoDeduccion > 0) {
          setShowDialogDeducciones(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creado",
      headerEn: "Date Created",
      Format: "DateTime",
      className: "medium",
    },
    {
      field: "UserNameCreate",
      header: "Creado Por",
      headerEn: "Created By",
      className: "medium",
    },
    {
      field: "DateEditStr",
      header: "Fecha Editado",
      headerEn: "Date Edited",
      Format: "DateTime",
      className: "medium",
    },
    {
      field: "UserNameEdit",
      header: "Editado Por",
      headerEn: "Edited By",
      className: "medium",
    },
    {
      field: "IdMotivoDeduccion",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdMotivoDeduccion > 0) {
              setShowDialogDeducciones(true);
              setSelected([rowData]);
            }
          },
        },
      ],
    },
  ];

  const tableDeducciones = {
    Columns: columnsDeducciones,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {},
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Maestros", config.language));
    getInfo();
  }, [activeIndex]);


  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Maestros", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                if(activeIndex === 0){
                  setShowDialog(true);
                  setSelected([]);
                }else if(activeIndex === 1){
                  setShowDialogTurnos(true);
                  setSelected([]);
                } else if(activeIndex === 2){
                  setShowDialogPagos(true);
                  setSelected([]);
                }else if(activeIndex === 3){
                  setShowDialogDeducciones(true);
                  setSelected([]);
                }
              }}
            />
          </div>
        }
        contenido={
          <div>
            <TabView
              className="mt-4"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel
                header={getLabel(baseLang, "Planillas", config.language)}
              >
                <div style={{ height: "83vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>
              <TabPanel header={getLabel(baseLang, "Turnos", config.language)}>
                <div style={{ height: "83vh" }}>
                  <AgGrid table={tableTurnos} />
                </div>
              </TabPanel>
              <TabPanel header={getLabel(baseLang, "Motivos de Pago", config.language)}>
                <div style={{ height: "83vh" }}>
                  <AgGrid table={tablePago} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "Motivos de Deducciones", config.language)}>
                <div style={{ height: "83vh" }}>
                  <AgGrid table={tableDeducciones} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      {showDialog && (
        <NominasCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          modo={selected?.length > 0 ? "Editar" : "Crear"}
        />
      )}

      {showDialogTurnos && (
        <TurnosCRUD
          showDialog={showDialogTurnos}
          setShowDialog={setShowDialogTurnos}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          modo={selected?.length > 0 ? "Editar" : "Crear"}
        />
      )}

      {showDialogPagos && (
        <MotivosPagoCRUD
          showDialog={showDialogPagos}
          setShowDialog={setShowDialogPagos}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          modo={selected?.length > 0 ? "Editar" : "Crear"}
        />
      )}
      
      {showDialogDeducciones && (
        <MotivosDeduccionesCRUD
          showDialog={showDialogDeducciones}
          setShowDialog={setShowDialogDeducciones}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          modo={selected?.length > 0 ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default MaestrosScreen;
